/* eslint-disable */
export default {
  columns: [
    { name: "ID", label: "Id", type: "NUMBER" },
    { name: "USER", label: "User", type: "TEXT" },
    { name: "ALT_USER", label: "Altuser", type: "TEXT" },
    { name: "TX_SOLUCIONES", label: "Soluciones", type: "TEXT" },
    { name: "PHOTO", label: "Foto", type: "IMAGE" },
    { name: "CV_DELEGACION", label: "Delegación", type: "NUMBER" },
    { name: "CV_CREDITO", label: "Crédito", type: "NUMBER" },
    { name: "CV_POOL", label: "Pool (phone)", type: "PHONE" },
    { name: "CV_VISITA", label: "Número de visitas", type: "NUMBER" },
    { name: "UBICACION", label: "Ubicación", type: "MAP" },
    { name: "SL_FPP", label: "Fpp (numérico)", type: "NUMBER" },
    { name: "SL_BCN", label: "Bcn (fecha)", type: "DATE" },
    { name: "SL_STM", label: "Stm (fecha y hora)", type: "DATETIME" },
    { name: "SL_DCP", label: "Dcp (hora)", type: "TIME" },
    { name: "SL_LIQ", label: "Liq (correo)", type: "EMAIL" },
    { name: "FH_OTORGAMIENTO", label: "Fecha de otorgamiento", type: "DATE" },
    { name: "CV_ESTATUS_CONTABLE", label: "Estatus contable (selección)", type: "SELECTION" },
    { name: "IM_SALDO", label: "Saldo (moneda)", type: "CURRENCY" },
    { name: "IM_MONTO_DESCUENTO", label: "Monto de descuento", type: "NUMBER" },
    { name: "IM_MONTO_LIQUIDAR_CON_DESCUENTO", label: "Monto por liquidar", type: "NUMBER" },
    { name: "CT_FACTOR_REA_ORIGINAL", label: "Factor rea", type: "NUMBER" },
    { name: "IM_PAGO_MENSUAL_SIN_SEG_DAN", label: "Pago mensual sin seguro", type: "NUMBER" },
    { name: "IM_PRIMA_SEG_DAN", label: "Prima de seguros", type: "NUMBER" },
    { name: "IM_PAGO_MENSUAL", label: "Pago mensual total", type: "NUMBER" },
    { name: "TX_ULTIMA_GESTION_4MESES", label: "Última gestión 4 meses", type: "TEXT" },
    { name: "TX_ULTIMA_GESTION_3MESES", label: "Última gestión 3 meses", type: "TEXT" },
    { name: "TX_ULTIMA_GESTION_2MESES", label: "Última gestión 2 meses", type: "TEXT" },
    { name: "TX_ULTIMA_GESTION_1MES", label: "Última gestión 1 meses", type: "TEXT" },
    { name: "TX_VECTOR_PAGOS", label: "Vector pagos", type: "NUMBER" }
  ],
  data: [
    {
      "ID": 123456,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 1,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 19930115,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 1470654.93,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 1470654.93,
      "CT_FACTOR_REA_ORIGINAL": 3199.34,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 954.81,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 967.31,
      "TX_ULTIMA_GESTION_4MESES": "BAGON/Promesa de Pago/VALIDAS APROBADAS/19.3242205,-98.9389821,2282.3",
      "TX_ULTIMA_GESTION_3MESES": "BAGON/Promesa de Pago/VALIDAS APROBADAS/19.3242177,-98.9389824,2275.2",
      "TX_ULTIMA_GESTION_2MESES": "BAGON/Promesa de pago/VALIDAS APROBADAS/19.3242205,-98.9389821,2282.3",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/Promesa de pago/VALIDAS APROBADAS/19.42088539899911,-99.0911959111690",
      "TX_VECTOR_PAGOS": 1111
    },
    {
      "ID": 123457,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM   DCP",
      "PHOTO": "https://images.unsplash.com/photo-1529619768328-e37af76c6fe5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 2,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        20.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 19960820,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 268584.07,
      "IM_MONTO_DESCUENTO": 53716.82,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 214867.25,
      "CT_FACTOR_REA_ORIGINAL": 2586.97,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2681.95,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2731.94,
      "TX_ULTIMA_GESTION_4MESES": "SERTEC/No contestan/SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_3MESES": "SERTEC/No contestan//",
      "TX_ULTIMA_GESTION_2MESES": "SERTEC/No contestan//",
      "TX_ULTIMA_GESTION_1MES": "SERTEC/Promesa de pago/VALIDAS APROBADAS/19.49901,-99.040754,2222.3",
      "TX_VECTOR_PAGOS": 1000
    },
    {
      "ID": 123458,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM   DCP",
      "PHOTO": "https://images.unsplash.com/photo-1529619768328-e37af76c6fe5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 3,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20110609,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 580526.55,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 580526.55,
      "CT_FACTOR_REA_ORIGINAL": 4274.12,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 4274.13,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 4411.6,
      "TX_ULTIMA_GESTION_4MESES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.501802,-99.0418053,2161.4878",
      "TX_ULTIMA_GESTION_3MESES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.610955433408094,-98.99286244064",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM//SIN ASIGNAR 2DA VISITA/19.501802,-99.0418053,2161.4878",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.581368801491593,-99.02492221444",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123459,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 4,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "No",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20110810,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 404794.9,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 404794.9,
      "CT_FACTOR_REA_ORIGINAL": 2739.44,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1274.74,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1324.73,
      "TX_ULTIMA_GESTION_4MESES": "SERTEC/Promesa de Pago/VALIDAS APROBADAS/19.634965,-98.9420396,2291.2",
      "TX_ULTIMA_GESTION_3MESES": "SERTEC/Promesa de Pago/VALIDAS APROBADAS/19.6349417,-98.94178,2294.4",
      "TX_ULTIMA_GESTION_2MESES": "SERTEC/Promesa de pago/VALIDAS APROBADAS/19.634965,-98.9420396,2291.2",
      "TX_ULTIMA_GESTION_1MES": "SERTEC//SIN ASIGNAR/",
      "TX_VECTOR_PAGOS": 1000
    },
    {
      "ID": 123460,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 5,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20100729,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 414465.43,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 414465.43,
      "CT_FACTOR_REA_ORIGINAL": 3481.79,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3619.26,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 3926.7,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/FPP/VALIDAS APROBADAS/19.6867284,-98.99078875,2248.0",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/Promesa de Pago/VALIDAS APROBADAS/19.5617313,-99.0522,2249.4",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/FPP/VALIDAS APROBADAS/19.6867284,-98.99078875,2248.0",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.697365103491393,-99.07779123634",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123461,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 6,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": null,
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20051115,
      "CV_ESTATUS_CONTABLE": "VEN",
      "IM_SALDO": 281340.23,
      "IM_MONTO_DESCUENTO": 42201.04,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 239139.19,
      "CT_FACTOR_REA_ORIGINAL": 3136.86,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3136.86,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 3199.35,
      "TX_ULTIMA_GESTION_4MESES": "NULL",
      "TX_ULTIMA_GESTION_3MESES": "NULL",
      "TX_ULTIMA_GESTION_2MESES": "NULL",
      "TX_ULTIMA_GESTION_1MES": "NULL",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123462,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDFPP",
      "PHOTO": "",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 7,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "Si",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20160429,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 363062.46,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 363062.46,
      "CT_FACTOR_REA_ORIGINAL": 3191.32,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2908.97,
      "IM_PRIMA_SEG_DAN": 12.49,
      "IM_PAGO_MENSUAL": 2915.37,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/FPP/VALIDAS APROBADAS/19.5987309,-99.0499782,2252.2",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/FPP/VALIDAS APROBADAS/19.6244289,-99.0305987,2236.9",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/FPP/VALIDAS APROBADAS/19.5987309,-99.0499782,2252.2",
      "TX_ULTIMA_GESTION_1MES": "///",
      "TX_VECTOR_PAGOS": 1110
    },
    {
      "ID": 123463,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   DCP",
      "PHOTO": "",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 8,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "No",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20030828,
      "CV_ESTATUS_CONTABLE": "VEN",
      "IM_SALDO": 183527.04,
      "IM_MONTO_DESCUENTO": 36705.41,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 146821.63,
      "CT_FACTOR_REA_ORIGINAL": 1872.11,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1407.21,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1832.12,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/Promesa de pago requerido/VALIDAS APROBADAS/19.3996001,-99.1563364,22",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "MU?OZ/Convenio DCP/VALIDAS APROBADAS/19.3996001,-99.1563364,2230.2",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/Convenio DCP/VALIDAS APROBADAS/19.3995815,-99.1564832,0.0",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123464,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 9,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 19991014,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 439854.33,
      "IM_MONTO_DESCUENTO": 87970.87,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 351883.46,
      "CT_FACTOR_REA_ORIGINAL": 4234.13,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 734.85,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 822.33,
      "TX_ULTIMA_GESTION_4MESES": "///",
      "TX_ULTIMA_GESTION_3MESES": "///",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM/Buzon de voz//",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.3307862,-98.8810033,2263.0",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123465,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 10,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "No",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20000717,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 407743.09,
      "IM_MONTO_DESCUENTO": 61161.47,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 346581.62,
      "CT_FACTOR_REA_ORIGINAL": 5546.36,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2429.5,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2591.96,
      "TX_ULTIMA_GESTION_4MESES": "MEXDAM/Promesa de Pago/VALIDAS APROBADAS/19.5897746,-99.0148831,2228.4",
      "TX_ULTIMA_GESTION_3MESES": "MEXDAM/Promesa de Pago/VALIDAS APROBADAS/19.6097218,-99.0278847,2207.4",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.5897746,-99.0148831,2228.4",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/No se pudo comprobar/VALIDAS APROBADAS/19.60863755601539,-99.03073187",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123466,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 11,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20120716,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 318410.03,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 318410.03,
      "CT_FACTOR_REA_ORIGINAL": 2007.09,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1984.6,
      "IM_PRIMA_SEG_DAN": 37.49,
      "IM_PAGO_MENSUAL": 1997.1,
      "TX_ULTIMA_GESTION_4MESES": "GC&C/Promesa de Pago/VALIDAS APROBADAS/19.7985428,-99.0656008,2242.0",
      "TX_ULTIMA_GESTION_3MESES": "GC&C/Promesa de Pago/VALIDAS APROBADAS/19.7982654,-99.0656461,2254.2",
      "TX_ULTIMA_GESTION_2MESES": "GC&C/Promesa de pago/VALIDAS APROBADAS/19.7985428,-99.0656008,2242.0",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Promesa de pago/VALIDAS APROBADAS/19.7982987,-99.0636622,2255.0",
      "TX_VECTOR_PAGOS": 1011
    },
    {
      "ID": 123467,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDFPP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 12,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "Si",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20120801,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 548358.11,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 548358.11,
      "CT_FACTOR_REA_ORIGINAL": 4374.1,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 4364.1,
      "IM_PRIMA_SEG_DAN": 1919.61,
      "IM_PAGO_MENSUAL": 6361.2,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/FPP/VALIDAS APROBADAS/19.5988251,-99.0499955,2251.5",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/Negativa de Pago/VALIDAS APROBADAS/19.6297903,-98.9379705,0.0",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Negativa de pago/VALIDAS APROBADAS/19.5988251,-99.0499955,2251.5",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.598485750187056,-98.97845495492",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123468,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 13,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20130109,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 167633.29,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 167633.29,
      "CT_FACTOR_REA_ORIGINAL": 824.83,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 824.83,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1012.29,
      "TX_ULTIMA_GESTION_4MESES": "BAGON//MOVIL/",
      "TX_ULTIMA_GESTION_3MESES": "BAGON//SIN ASIGNAR MAYOR A 3RA VISITA/",
      "TX_ULTIMA_GESTION_2MESES": "BAGON//SIN ASIGNAR MAYOR A 3RA VISITA/",
      "TX_ULTIMA_GESTION_1MES": "BARRERA/No se pudo comprobar/VALIDAS APROBADAS/19.6470726,-99.02807594,2231",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123469,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 14,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20121019,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 424308.42,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 424308.42,
      "CT_FACTOR_REA_ORIGINAL": 3629.25,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3626.76,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 3676.75,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Promesa de Pago//",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/Promesa de Pago//",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Promesa de pago/VALIDAS APROBADAS/",
      "TX_ULTIMA_GESTION_1MES": "BARRERA/Promesa de pago/VALIDAS APROBADAS/19.80242203,-99.05516817,2272.495",
      "TX_VECTOR_PAGOS": 1000
    },
    {
      "ID": 123470,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 15,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20121210,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 426777.92,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 426777.92,
      "CT_FACTOR_REA_ORIGINAL": 4311.62,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 4311.62,
      "IM_PRIMA_SEG_DAN": 77.48,
      "IM_PAGO_MENSUAL": 5551.37,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Promesa de Pago/VALIDAS APROBADAS/19.6141408,-99.2037883,2260.4",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Negativa de pago/VALIDAS APROBADAS/19.6141408,-99.2037883,2260.4",
      "TX_ULTIMA_GESTION_1MES": "BEAMBER/Interrumpida//",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123471,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDCONFPR",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 16,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20081001,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 253587.68,
      "IM_MONTO_DESCUENTO": 76076.31,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 177511.37,
      "CT_FACTOR_REA_ORIGINAL": 1417.21,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1414.71,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1527.19,
      "TX_ULTIMA_GESTION_4MESES": "///",
      "TX_ULTIMA_GESTION_3MESES": "///",
      "TX_ULTIMA_GESTION_2MESES": "DIL//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_1MES": "DIL/Promesa de pago requerido/VALIDAS APROBADAS/19.8107225,-99.044061,2263.",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123472,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 17,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20061122,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 453277.61,
      "IM_MONTO_DESCUENTO": 67991.64,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 385285.96,
      "CT_FACTOR_REA_ORIGINAL": 2859.41,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2854.42,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2979.39,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.606558,-99.1853472,2247.5",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.63705635,-99.03645555,2221.1",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.606558,-99.1853472,2247.5",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.638161,-99.0389952,2233.9",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123473,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 15,
      "CV_CREDITO": 18,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20130717,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 346121.88,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 346121.88,
      "CT_FACTOR_REA_ORIGINAL": 3309.32,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3306.83,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 3344.32,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/Vivienda no localizada/VALIDAS APROBADAS/19.3338861,-99.6871887,0.0",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ/No se pudo comprobar/VALIDAS APROBADAS/19.3791545,-99.7596368,2598.3",
      "TX_ULTIMA_GESTION_2MESES": "MU?OZ/Vivienda Abandonada/VALIDAS APROBADAS/19.3338861,-99.6871887,0.0",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/No se pudo comprobar/VALIDAS APROBADAS/19.3791736,-99.759788,0.0",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123474,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 19,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20061227,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 372633.07,
      "IM_MONTO_DESCUENTO": 55894.97,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 316738.09,
      "CT_FACTOR_REA_ORIGINAL": 3066.87,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2849.42,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2874.41,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Promesa de Pago/VALIDAS APROBADAS/19.64244635,-99.02193435,2246.781",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA///19.64244635,-99.02193435,2246.7817",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.4245812,-98.9018638,0.0",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123475,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 20,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 19960822,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 653730.03,
      "IM_MONTO_DESCUENTO": 261492.02,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 392238.01,
      "CT_FACTOR_REA_ORIGINAL": 829.83,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1054.78,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1167.26,
      "TX_ULTIMA_GESTION_4MESES": "BAGON//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_3MESES": "BAGON//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "BAGON//SIN ASIGNAR 3RA VISITA/",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.3103865,-98.8605188,2261.2002",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123476,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 21,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20130712,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 331449.87,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 331449.87,
      "CT_FACTOR_REA_ORIGINAL": 4279.12,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1324.73,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1337.23,
      "TX_ULTIMA_GESTION_4MESES": "GC&C/Promesa de Pago/VALIDAS APROBADAS/19.4224017,-98.88061,2252.0",
      "TX_ULTIMA_GESTION_3MESES": "GC&C/Vivienda habitada por un familiar indirecto o tercero/VALIDAS APROBADA",
      "TX_ULTIMA_GESTION_2MESES": "GC&C/Vivienda habitada por un familiar indirecto o tercero/VALIDAS APROBADA",
      "TX_ULTIMA_GESTION_1MES": "SCORE/No contestan//",
      "TX_VECTOR_PAGOS": 10
    },
    {
      "ID": 123477,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDFPP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 22,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "Si",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20110628,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 378612.75,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 378612.75,
      "CT_FACTOR_REA_ORIGINAL": 3909.2,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3909.2,
      "IM_PRIMA_SEG_DAN": 77.48,
      "IM_PAGO_MENSUAL": 4141.64,
      "TX_ULTIMA_GESTION_4MESES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.2629157,-98.8460308,2280.4",
      "TX_ULTIMA_GESTION_3MESES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.4792249,-99.1255623,2228.1",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.2629157,-98.8460308,2280.4",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.4945781,-99.2201699,2253.4001",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123478,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 23,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20161017,
      "CV_ESTATUS_CONTABLE": "VEN",
      "IM_SALDO": 456032.77,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 456032.77,
      "CT_FACTOR_REA_ORIGINAL": 4034.91,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3373.93,
      "IM_PRIMA_SEG_DAN": 12.49,
      "IM_PAGO_MENSUAL": 3472.24,
      "TX_ULTIMA_GESTION_4MESES": "NULL",
      "TX_ULTIMA_GESTION_3MESES": "NULL",
      "TX_ULTIMA_GESTION_2MESES": "NULL",
      "TX_ULTIMA_GESTION_1MES": "NULL",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123479,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 24,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20110826,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 525470.28,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 525470.28,
      "CT_FACTOR_REA_ORIGINAL": 5518.87,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3216.84,
      "IM_PRIMA_SEG_DAN": 852.33,
      "IM_PAGO_MENSUAL": 4146.64,
      "TX_ULTIMA_GESTION_4MESES": "SERTEC/Promesa de Pago/VALIDAS APROBADAS/19.6926878,-99.0070206,2236.2",
      "TX_ULTIMA_GESTION_3MESES": "SERTEC/Promesa de Pago/VALIDAS APROBADAS/19.6926003,-99.0069619,2236.7",
      "TX_ULTIMA_GESTION_2MESES": "SERTEC/No se pudo comprobar/VALIDAS APROBADAS/19.6926878,-99.0070206,2236.2",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda habitada por un familiar indirecto o tercero/VALIDAS APROBADA",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123480,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 25,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20020816,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 260530.83,
      "IM_MONTO_DESCUENTO": 52106.17,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 208424.66,
      "CT_FACTOR_REA_ORIGINAL": 1812.13,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1169.76,
      "IM_PRIMA_SEG_DAN": 0,
      "IM_PAGO_MENSUAL": 1182.26,
      "TX_ULTIMA_GESTION_4MESES": "BAGON/Promesa de Pago/VALIDAS APROBADAS/19.4118773,-99.0317976,0.0",
      "TX_ULTIMA_GESTION_3MESES": "BAGON//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "BAGON/Promesa de pago/VALIDAS APROBADAS/19.4118773,-99.0317976,0.0",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.4819634,-99.123914,2228.9001",
      "TX_VECTOR_PAGOS": 1
    },
    {
      "ID": 123481,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 26,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20140623,
      "CV_ESTATUS_CONTABLE": "VEN",
      "IM_SALDO": 322479.2,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 322479.2,
      "CT_FACTOR_REA_ORIGINAL": 1889.61,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1889.61,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2064.57,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.6153747,-99.1980163,2251.4",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.6182989,-99.0139775,2239.6",
      "TX_ULTIMA_GESTION_2MESES": "BAGON/Vivienda habitada por un familiar indirecto o tercero/VALIDAS APROBAD",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.6158601,-99.0015945,2244.0",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123482,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 27,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20100119,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 688654.49,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 688654.49,
      "CT_FACTOR_REA_ORIGINAL": 4211.64,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 4211.64,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 4236.63,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/FPP/VALIDAS APROBADAS/19.5027218,-99.1153874,2234.6",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ/Promesa de Pago/VALIDAS APROBADAS/19.3870395,-99.0359688,2223.3",
      "TX_ULTIMA_GESTION_2MESES": "MU?OZ/Promesa de pago/VALIDAS APROBADAS/19.5027218,-99.1153874,2234.6",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.7202366,-98.9784112,2251.9",
      "TX_VECTOR_PAGOS": 1001
    },
    {
      "ID": 123483,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 28,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20050701,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 108349.19,
      "IM_MONTO_DESCUENTO": 16252.38,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 92096.81,
      "CT_FACTOR_REA_ORIGINAL": 4679.04,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 4679.05,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 4916.5,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.67330291142878,-98.97407457232",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.6207224,-99.0424554,2234.8",
      "TX_ULTIMA_GESTION_2MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.67330291142878,-98.97407457232",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.673552002658077,-98.9739397913",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123484,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 29,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20041005,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 609260.43,
      "IM_MONTO_DESCUENTO": 121852.09,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 487408.34,
      "CT_FACTOR_REA_ORIGINAL": 3846.71,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3839.22,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 3976.69,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.6005757,-98.9773581,2235.2",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.6723788,-98.9711479,2354.3",
      "TX_ULTIMA_GESTION_2MESES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.6005757,-98.9773581,2235.2",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.41672510993553,-98.88694334775",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123485,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDFPP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 30,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "Si",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20120917,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 251416.2,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 251416.2,
      "CT_FACTOR_REA_ORIGINAL": 2481.99,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2481.98,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2506.98,
      "TX_ULTIMA_GESTION_4MESES": "///",
      "TX_ULTIMA_GESTION_3MESES": "///",
      "TX_ULTIMA_GESTION_2MESES": "FRANMED///",
      "TX_ULTIMA_GESTION_1MES": "FRANMED///",
      "TX_VECTOR_PAGOS": 10
    },
    {
      "ID": 123486,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 31,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20000630,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 220512.86,
      "IM_MONTO_DESCUENTO": 88205.15,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 132307.71,
      "CT_FACTOR_REA_ORIGINAL": 1379.71,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 669.86,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 694.85,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ///",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ///",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ///",
      "TX_VECTOR_PAGOS": 10
    },
    {
      "ID": 123487,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDFPP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 32,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "Si",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20140925,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 423793.53,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 423793.53,
      "CT_FACTOR_REA_ORIGINAL": 3944.19,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3944.2,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 4119.16,
      "TX_ULTIMA_GESTION_4MESES": "BAGON/FPP/VALIDAS APROBADAS/19.7017462,-99.0672082,2234.0",
      "TX_ULTIMA_GESTION_3MESES": "BAGON/FPP/VALIDAS APROBADAS/19.703691076323363,-99.06715862452984,0.0",
      "TX_ULTIMA_GESTION_2MESES": "BAGON//MOVIL/19.7017462,-99.0672082,2234.0",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.707826607802854,-99.06926985830",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123488,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 33,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20090512,
      "CV_ESTATUS_CONTABLE": "VEN",
      "IM_SALDO": 162395.24,
      "IM_MONTO_DESCUENTO": 24359.29,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 138035.95,
      "CT_FACTOR_REA_ORIGINAL": 2292.03,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2289.53,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2302.03,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.8006918,-99.0123593,0.0",
      "TX_ULTIMA_GESTION_3MESES": "Mediacion//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Convenio BCN/VALIDAS APROBADAS/19.8006918,-99.0123593,0.0",
      "TX_ULTIMA_GESTION_1MES": "BARRERA/Promesa de pago requerido/VALIDAS APROBADAS/19.616332,-99.0667538,0",
      "TX_VECTOR_PAGOS": 11
    },
    {
      "ID": 123489,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 34,
      "CV_POOL": 2,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20110702,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 157052.95,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 157052.95,
      "CT_FACTOR_REA_ORIGINAL": 842.32,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 842.33,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 879.82,
      "TX_ULTIMA_GESTION_4MESES": "BAGON//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_3MESES": "BAGON/Promesa de Pago/VALIDAS APROBADAS/",
      "TX_ULTIMA_GESTION_2MESES": "BEAMBER/No contestan/SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Promesa de pago/VALIDAS APROBADAS/19.6108382,-99.0093769,2240.0",
      "TX_VECTOR_PAGOS": 100
    },
    {
      "ID": 123490,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 15,
      "CV_CREDITO": 35,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20130902,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 406149.63,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 406149.63,
      "CT_FACTOR_REA_ORIGINAL": 7700.92,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 7700.93,
      "IM_PRIMA_SEG_DAN": 77.48,
      "IM_PAGO_MENSUAL": 8243.32,
      "TX_ULTIMA_GESTION_4MESES": "MEXDAM/Promesa de Pago/VALIDAS APROBADAS/19.2877946,-99.6583253,2670.7",
      "TX_ULTIMA_GESTION_3MESES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.30392,-99.7414957,0.0",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM//MOVIL/19.2877946,-99.6583253,2670.7",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/Vivienda no localizada/VALIDAS APROBADAS/19.3825296,-99.6367918,2575.",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123491,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDFPP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 36,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "Si",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20170224,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 297130.32,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 297130.32,
      "CT_FACTOR_REA_ORIGINAL": 3496.21,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2567.26,
      "IM_PRIMA_SEG_DAN": 12.49,
      "IM_PAGO_MENSUAL": 3017.5,
      "TX_ULTIMA_GESTION_4MESES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/",
      "TX_ULTIMA_GESTION_3MESES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.807280670044626,-99.05320107936",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/",
      "TX_ULTIMA_GESTION_1MES": "FRANMED///",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123492,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 37,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "No",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 19960604,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 434236.12,
      "IM_MONTO_DESCUENTO": 86847.23,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 347388.89,
      "CT_FACTOR_REA_ORIGINAL": 2506.98,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1782.14,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1857.12,
      "TX_ULTIMA_GESTION_4MESES": "BAGON/Promesa de Pago/VALIDAS APROBADAS/19.330966969898874,-98.955238424241",
      "TX_ULTIMA_GESTION_3MESES": "BAGON//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "BAGON//SIN ASIGNAR 2DA VISITA/19.330966969898874,-98.95523842424154,0.0",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda invadida/VALIDAS APROBADAS/19.3145302,-98.9306165,2242.6",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123493,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 38,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20120626,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 25724.75,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 25724.75,
      "CT_FACTOR_REA_ORIGINAL": 560,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 557.39,
      "IM_PRIMA_SEG_DAN": 17.5,
      "IM_PAGO_MENSUAL": 869.83,
      "TX_ULTIMA_GESTION_4MESES": "BAGON//MOVIL/",
      "TX_ULTIMA_GESTION_3MESES": "BAGON//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "BAGON//MOVIL/",
      "TX_ULTIMA_GESTION_1MES": "GC&C/Vivienda no localizada/VALIDAS APROBADAS/19.4189783,-98.9244117,1415.9",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123494,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDBCN   STM   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 39,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "Si",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20070703,
      "CV_ESTATUS_CONTABLE": "VEN",
      "IM_SALDO": 520020.84,
      "IM_MONTO_DESCUENTO": 78003.13,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 442017.71,
      "CT_FACTOR_REA_ORIGINAL": 3574.27,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3576.77,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 3884.21,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.8628853,-99.2297289,2306.2622",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.813475483936994,-98.9862843230",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.8628853,-99.2297289,2306.262",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.7822961,-99.0102259,2226.6",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123495,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDSTM   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 15,
      "CV_CREDITO": 40,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20160805,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 676651.3,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 676651.3,
      "CT_FACTOR_REA_ORIGINAL": 5552.28,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 5552.28,
      "IM_PRIMA_SEG_DAN": 12.49,
      "IM_PAGO_MENSUAL": 5970.84,
      "TX_ULTIMA_GESTION_4MESES": "MEXDAM/No se pudo comprobar/VALIDAS APROBADAS/19.2633021,-99.6018211,5.2",
      "TX_ULTIMA_GESTION_3MESES": "MEXDAM/Vivienda invadida/VALIDAS APROBADAS/19.2878398,-99.6584582,2643.0",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.2633021,-99.6018211,5.2",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/No se pudo comprobar/VALIDAS APROBADAS/19.2644117,-99.5996883,2565.7",
      "TX_VECTOR_PAGOS": 100
    },
    {
      "ID": 123496,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 41,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 19921207,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 516065.89,
      "IM_MONTO_DESCUENTO": 206426.36,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 309639.53,
      "CT_FACTOR_REA_ORIGINAL": 674.86,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1344.73,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1432.21,
      "TX_ULTIMA_GESTION_4MESES": "GC&C/Promesa de Pago/VALIDAS APROBADAS/19.6815928,-98.9979698,2247.4",
      "TX_ULTIMA_GESTION_3MESES": "GC&C/Promesa de Pago/VALIDAS APROBADAS/19.3994163,-99.13685699999999,0.0",
      "TX_ULTIMA_GESTION_2MESES": "GC&C/Promesa de pago/VALIDAS APROBADAS/19.6815928,-98.9979698,2247.4",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/No se pudo comprobar/VALIDAS APROBADAS/19.526138,-99.0399591,2224.6",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123497,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 42,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20070621,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 304722.81,
      "IM_MONTO_DESCUENTO": 45708.43,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 259014.38,
      "CT_FACTOR_REA_ORIGINAL": 2159.55,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2157.06,
      "IM_PRIMA_SEG_DAN": 434.91,
      "IM_PAGO_MENSUAL": 2604.46,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/No se pudo comprobar/VALIDAS APROBADAS/19.52919274617373,-99.21215113",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ//MOVIL/",
      "TX_ULTIMA_GESTION_2MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.52919274617373,-99.21215113252",
      "TX_ULTIMA_GESTION_1MES": "BARRERA///",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123498,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDSTM   DCP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 43,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "Si",
      "SL_DCP": "Si",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20150812,
      "CV_ESTATUS_CONTABLE": "VEN",
      "IM_SALDO": 415553.07,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 415553.07,
      "CT_FACTOR_REA_ORIGINAL": 3300.95,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2248.42,
      "IM_PRIMA_SEG_DAN": 12.49,
      "IM_PAGO_MENSUAL": 2294.59,
      "TX_ULTIMA_GESTION_4MESES": "BARRERA/Promesa de pago requerido/VALIDAS APROBADAS/19.5987357,-99.0499562,",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA/Promesa de pago requerido/VALIDAS APROBADAS/19.5879541,-99.0018927,",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Promesa de pago requerido/VALIDAS APROBADAS/19.5987357,-99.0499562,",
      "TX_ULTIMA_GESTION_1MES": "BARRERA/Negativa de pago/VALIDAS APROBADAS/19.6149869,-99.0022407,2242.2002",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123499,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 44,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20071220,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 665441.68,
      "IM_MONTO_DESCUENTO": 66544.17,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 598897.51,
      "CT_FACTOR_REA_ORIGINAL": 4229.13,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1907.11,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1994.59,
      "TX_ULTIMA_GESTION_4MESES": "MEXDAM/Promesa de Pago/VALIDAS APROBADAS/19.6464486,-99.0207158,2241.1",
      "TX_ULTIMA_GESTION_3MESES": "MEXDAM/Promesa de Pago/VALIDAS APROBADAS/19.646465,-99.0207325,2241.2",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.6464486,-99.0207158,2241.1",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.646395,-99.0209595,2242.8",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123500,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUIDFPP",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 45,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "Si",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20170608,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 38641.19,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 38641.19,
      "CT_FACTOR_REA_ORIGINAL": 1996,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2008.97,
      "IM_PRIMA_SEG_DAN": 12.49,
      "IM_PAGO_MENSUAL": 2008.97,
      "TX_ULTIMA_GESTION_4MESES": "MEXDAM/FPP/VALIDAS APROBADAS/19.8149262,-99.035934,0.0",
      "TX_ULTIMA_GESTION_3MESES": "MEXDAM/FPP/VALIDAS APROBADAS/19.8144298,-99.0387211,2248.5",
      "TX_ULTIMA_GESTION_2MESES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.8149262,-99.035934,0.0",
      "TX_ULTIMA_GESTION_1MES": "///",
      "TX_VECTOR_PAGOS": 1110
    },
    {
      "ID": 123501,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 46,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20150224,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 20145.89,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 20145.89,
      "CT_FACTOR_REA_ORIGINAL": 3271.83,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 3269.33,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 3294.32,
      "TX_ULTIMA_GESTION_4MESES": "GC&C/Promesa de Pago/VALIDAS APROBADAS/19.2982216,-98.9003048,2235.5",
      "TX_ULTIMA_GESTION_3MESES": "GC&C/Promesa de Pago/VALIDAS APROBADAS/19.2979294,-98.8998772,2234.7",
      "TX_ULTIMA_GESTION_2MESES": "GC&C/Promesa de pago/VALIDAS APROBADAS/19.2982216,-98.9003048,2235.5",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/Promesa de pago/VALIDAS APROBADAS/19.324790600112227,-98.876636959612",
      "TX_VECTOR_PAGOS": 101
    },
    {
      "ID": 123502,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 47,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20071219,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 346694.57,
      "IM_MONTO_DESCUENTO": 52004.19,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 294690.38,
      "CT_FACTOR_REA_ORIGINAL": 2591.97,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2164.56,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2339.52,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.6351914,-99.0371277,2237.7",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "MU?OZ///19.6351914,-99.0371277,2237.7",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ///",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123503,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 48,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20120806,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 209379.78,
      "IM_MONTO_DESCUENTO": 0,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 209379.78,
      "CT_FACTOR_REA_ORIGINAL": 1654.66,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1652.16,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1752.14,
      "TX_ULTIMA_GESTION_4MESES": "BAGON/Vivienda habitada por un familiar indirecto o tercero/VALIDAS APROBAD",
      "TX_ULTIMA_GESTION_3MESES": "BARRERA///",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA/Vivienda invadida/VALIDAS APROBADAS/19.692970455338447,-98.99875156",
      "TX_ULTIMA_GESTION_1MES": "BARRERA///",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123504,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 49,
      "CV_POOL": 1,
      "CV_VISITA": 1,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20051210,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 167118.85,
      "IM_MONTO_DESCUENTO": 25067.83,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 142051.01,
      "CT_FACTOR_REA_ORIGINAL": 2804.42,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 1367.22,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 1392.21,
      "TX_ULTIMA_GESTION_4MESES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.5973267,-98.9752245,2233.6",
      "TX_ULTIMA_GESTION_3MESES": "MU?OZ//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_2MESES": "MU?OZ/Negativa de pago/VALIDAS APROBADAS/19.5973267,-98.9752245,2233.6",
      "TX_ULTIMA_GESTION_1MES": "MU?OZ/Vivienda invadida/VALIDAS APROBADAS/19.5972179,-98.9752784,2227.0",
      "TX_VECTOR_PAGOS": 0
    },
    {
      "ID": 123505,
      "USER": "usertest",
      "ALT_USER": "alt_usertest",
      "TX_SOLUCIONES": "PAGO  LIQUID",
      "PHOTO": "https://cdn.pixabay.com/photo/2016/01/19/18/00/city-1150026_960_720.jpg",
      "CV_DELEGACION": 9,
      "CV_CREDITO": 50,
      "CV_POOL": 1,
      "CV_VISITA": 2,
      "UBICACION": [
        19.4335104,
        -99.211217
      ],
      "SL_FPP": "No",
      "SL_BCN": "No",
      "SL_STM": "No",
      "SL_DCP": "No",
      "SL_LIQ": "Si",
      "FH_OTORGAMIENTO": 20020405,
      "CV_ESTATUS_CONTABLE": "VIG",
      "IM_SALDO": 368954.61,
      "IM_MONTO_DESCUENTO": 73790.92,
      "IM_MONTO_LIQUIDAR_CON_DESCUENTO": 295163.68,
      "CT_FACTOR_REA_ORIGINAL": 2586.97,
      "IM_PAGO_MENSUAL_SIN_SEG_DAN": 2569.48,
      "IM_PRIMA_SEG_DAN": 12.5,
      "IM_PAGO_MENSUAL": 2606.96,
      "TX_ULTIMA_GESTION_4MESES": "BEAMBER/Buzon de voz/SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_3MESES": "BAGON/Promesa de Pago/VALIDAS APROBADAS/19.293067299660958,-98.899958766996",
      "TX_ULTIMA_GESTION_2MESES": "BARRERA//SIN ASIGNAR/",
      "TX_ULTIMA_GESTION_1MES": "MEXDAM/Promesa de pago/VALIDAS APROBADAS/19.2964825,-98.8949523,2235.7002",
      "TX_VECTOR_PAGOS": 1111
    }
  ]
}
